var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconarrowsdropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5303 6.94462C12.2374 6.65173 11.7625 6.65173 11.4696 6.94462L8.2374 10.1769C7.94451 10.4697 7.46963 10.4697 7.17674 10.1769L6.82319 9.8233C6.53029 9.53041 6.53029 9.05553 6.82319 8.76264L11.0732 4.51264C11.2138 4.37199 11.4046 4.29297 11.6035 4.29297H12.3964C12.5953 4.29297 12.7861 4.37199 12.9267 4.51264L17.1767 8.76264C17.4696 9.05553 17.4696 9.53041 17.1767 9.8233L16.8232 10.1769C16.5303 10.4697 16.0554 10.4697 15.7625 10.1769L12.5303 6.94462Z",
    fill: "#3B5118"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5303 17.0555C12.2374 17.3484 11.7625 17.3484 11.4696 17.0555L8.2374 13.8233C7.94451 13.5304 7.46963 13.5304 7.17674 13.8233L6.82319 14.1769C6.53029 14.4697 6.53029 14.9446 6.82319 15.2375L11.0732 19.4875C11.2138 19.6282 11.4046 19.7072 11.6035 19.7072H12.3964C12.5953 19.7072 12.7861 19.6282 12.9267 19.4875L17.1767 15.2375C17.4696 14.9446 17.4696 14.4697 17.1767 14.1769L16.8232 13.8233C16.5303 13.5304 16.0554 13.5304 15.7625 13.8233L12.5303 17.0555Z",
    fill: "#3B5118"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconarrowsdropdown);
export default __webpack_public_path__ + "static/media/icon.arrows.dropdown.a9e4532b3d9ac5f2c5d430867360108c.svg";
export { ForwardRef as ReactComponent };